import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import CompanyV2ServiceCard from "@/components/sections/company-v2/CompanyV2ServiceCard";
import { SERVICE_CARD_HREFS } from "@/lib/publicNav";

export default function CompanyV2ServiceCardItem({ service }) {
  const [flipped, setFlipped] = useState(false);
  const [arrowHover, setArrowHover] = useState(false);
  const Icon = service.Icon;

  const toggleFlip = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFlipped((v) => !v);
    setArrowHover(false);
  };

  const showHorizontalArrow = arrowHover;

  return (
    <CompanyV2ServiceCard testId={`service-card-${service.id}`} flipped={flipped}>
      <div className={`ds-company-v2-service-card__flipper${flipped ? " is-flipped" : ""}`}>
        <div className="ds-company-v2-service-card__face ds-company-v2-service-card__face--front">
          <div className="group p-7 md:p-8 h-full min-h-[17.5rem] flex flex-col">
            <div className="flex items-start justify-between">
              <div className="h-12 w-12 rounded-2xl bg-white border border-slate-100 text-[#0A2540] flex items-center justify-center group-hover:bg-[#0A2540] group-hover:text-white group-hover:border-[#0A2540] transition-colors">
                <Icon size={20} strokeWidth={1.5} />
              </div>
              <button
                type="button"
                data-testid={`service-card-flip-${service.id}`}
                className="ds-company-v2-service-card__flip-btn"
                aria-label={`${service.title} 상세 보기`}
                aria-expanded={flipped}
                onMouseEnter={() => setArrowHover(true)}
                onMouseLeave={() => setArrowHover(false)}
                onClick={toggleFlip}
              >
                {showHorizontalArrow ? (
                  <ArrowRight size={18} className="ds-company-v2-service-card__flip-icon" />
                ) : (
                  <ArrowUpRight size={18} className="ds-company-v2-service-card__flip-icon" />
                )}
              </button>
            </div>
            <div className="mt-7 flex-1">
              <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-slate-400">
                {service.en}
              </div>
              <h3 className="font-kr mt-2 text-lg md:text-[19px] font-bold tracking-tight text-slate-900">
                {SERVICE_CARD_HREFS[service.id] ? (
                  <Link to={SERVICE_CARD_HREFS[service.id]} className="hover:underline">
                    {service.title}
                  </Link>
                ) : (
                  service.title
                )}
              </h3>
              <p className="font-kr mt-3 text-sm text-slate-600 leading-relaxed">{service.desc}</p>
            </div>
          </div>
        </div>

        <div className="ds-company-v2-service-card__face ds-company-v2-service-card__face--back">
          <div className="ds-company-v2-service-card__back-scroll">
            <div className="ds-company-v2-service-card__back-inner">
            <div className="ds-company-v2-service-card__back-head">
              <div className="min-w-0">
                <span className="ds-company-v2-service-card__back-eyebrow">{service.en}</span>
                <h3 className="ds-company-v2-service-card__back-title">{service.title}</h3>
              </div>
              <button
                type="button"
                data-testid={`service-card-flip-back-${service.id}`}
                className="ds-company-v2-service-card__flip-btn shrink-0"
                aria-label={`${service.title} 앞면으로 돌아가기`}
                aria-expanded={flipped}
                onClick={toggleFlip}
              >
                <ArrowRight
                  size={18}
                  className="ds-company-v2-service-card__flip-icon ds-company-v2-service-card__flip-icon--back"
                />
              </button>
            </div>

            <p className="ds-company-v2-service-card__back-intro">{service.backIntro}</p>

            <div className="ds-company-v2-service-card__back-section">
              <span className="ds-company-v2-service-card__back-label">주요 기능</span>
              <ul className="ds-company-v2-service-card__back-list">
                {service.features.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>

            <div className="ds-company-v2-service-card__back-audience">
              <span className="ds-company-v2-service-card__back-label ds-company-v2-service-card__back-label--light">
                추천 대상
              </span>
              <p className="ds-company-v2-service-card__back-audience-text">{service.audience}</p>
            </div>
            </div>
            <div className="ds-company-v2-service-card__back-scroll-hint" aria-hidden="true">
              아래로 스크롤
            </div>
          </div>
        </div>
      </div>
    </CompanyV2ServiceCard>
  );
}
